import React from 'react';
const DropdownContext = /*#__PURE__*/React.createContext({
  level: 0
});
export default DropdownContext;